import React from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import LoginPage from '@src/pages/login'
import Root from '@src/components/root'
import ErrorPage from '@src/pages/error-page'
import Dashboard from '@src/pages/dashboard'
import DataImport from '@src/pages/data-import'
import Report from '@src/pages/report'
import Setting from '@src/pages/setting'
import SystemManagement from '@src/pages/system-management'
import { StoreProvider } from '@src/store/StoreProvider'
import { QueryProvider } from '@src/lib/react-query'
import { AuthProvider } from '@src/components/auth'
import { PermissionsProvider } from '@src/components/permissions'
import { ModalManagerProvider } from '@src/lib/modal-manager'
import { SpinnerProvider } from '@src/components/spinner'

const appRouter = createBrowserRouter(
  [
    {
      path: '/login',
      element: <LoginPage />
    },
    {
      element: <Root />,
      errorElement: <ErrorPage />,
      children: [
        {
          path: '/',
          element: <Dashboard />
        },
        {
          path: '/data-import/:category',
          element: <DataImport />
        },
        {
          path: '/report/:category',
          element: <Report />
        },
        {
          path: '/setting/:category',
          element: <Setting />
        },
        {
          path: '/system-management/:category',
          element: <SystemManagement />
        }
      ]
    }
  ],
  {
    future: {
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_relativeSplatPath: true,
      v7_skipActionErrorRevalidation: true
    }
  }
)

const AppWithRouter: React.FC = () => {
  return <RouterProvider router={appRouter} future={{ v7_startTransition: true }} />
}

const WithOtherProvider: React.FC = () => {
  return (
    <StoreProvider>
      <QueryProvider>
        <SpinnerProvider>
          <AuthProvider>
            <PermissionsProvider>
              <ModalManagerProvider>
                <AppWithRouter />
              </ModalManagerProvider>
            </PermissionsProvider>
          </AuthProvider>
        </SpinnerProvider>
      </QueryProvider>
    </StoreProvider>
  )
}

export default WithOtherProvider
